<template>
  <b-modal
    v-model="showModal"
    v-bind="$attrs"
    title="FCP Start Date"
    content-class="global-umr-fcp-datepicker-modal"
    body-class="p-4"
    footer-class="py-3 px-4"
    @hide="handleSave"
  >
    <DatePicker v-model="date" :format="DATE_FORMAT" :clearable="false" />

    <template #modal-footer>
      <b-button variant="primary" class="ml-auto" @click="handleSave"
        >Save</b-button
      >
    </template>
  </b-modal>
</template>

<script>
import { defineComponent, computed, ref, watch } from '@vue/composition-api'
import { format, parse } from 'date-fns'

import DatePicker from 'vue2-datepicker'

export default defineComponent({
  name: 'BDXStatusModalFormFCPToggleDateModal',
  components: {
    DatePicker
  },
  props: {
    value: String,
    show: Boolean
  },
  emits: ['input', 'update:show'],
  setup(props, { emit }) {
    const DATE_FORMAT = 'MM-DD-YYYY'

    const date = ref(null)

    const handleSave = () => {
      emit('input', format(date.value || new Date(), DATE_FORMAT))

      emit('update:show', false)
    }

    const showModal = computed({
      get: () => props.show,
      set: (value) => emit('update:show', value)
    })

    watch(showModal, (newShowModal) => {
      if (!newShowModal) return

      date.value = parse(props.value || new Date())
    })

    return {
      DATE_FORMAT,

      date,
      handleSave,

      showModal
    }
  }
})
</script>

<style>
.global-umr-fcp-datepicker-modal .mx-datepicker {
  width: 100%;
}

.global-umr-fcp-datepicker-modal .mx-datepicker input {
  border-radius: 0 !important;
}
</style>
